import { render } from "./UserCreate.vue?vue&type=template&id=3a10a596"
import script from "./UserCreate.vue?vue&type=script&lang=js"
export * from "./UserCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/xs909715/manage-sys.net/deploy/call-center-fe/production/releases/5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__